export default "__VITE_ASSET__d87314fa__"